import { Bot } from "lucide-react";

/**
 * Telling a child that what answers them is an AI, not a person (AI Act art.
 * 50). Two forms because there are two moments: the badge on the press that
 * opens the tutor, so it is known before the conversation starts, and the line
 * under the panel's header, so it is still on screen while the chat goes on.
 */
export function AiBadge() {
  return (
    <span className="rounded bg-indigo-100 px-1 py-px text-[10px] font-semibold leading-none text-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-200">
      AI
    </span>
  );
}

export function AiNotice() {
  return (
    <p className="flex items-center gap-1.5 border-b border-indigo-200 px-4 py-1.5 text-xs text-indigo-700/80 dark:border-indigo-800 dark:text-indigo-300/80">
      <Bot className="h-3.5 w-3.5 shrink-0" />
      Su tavimi kalbasi dirbtinis intelektas (AI), ne žmogus. Jis kartais suklysta.
    </p>
  );
}
